<template>
     <transition name="overlay">
        <div class="overlay" v-if="store && p.visible">
            <div class="overlay-content">
                <img src="img/popup.jpg" />
                <div>
                    <h2>{{ p.title }}</h2>
                    <p>{{ p.description }}</p>
                </div>
                <button class="button button-primary" type="button" @click="p.visible = false">{{ $t("common.ok") }}</button>
                <span class="close icon-cross" @click="p.visible = false"></span>
            </div>
        </div>
    </transition>
</template>
  
<script lang="ts">
import { store } from "store";
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            store: store,
            p: store.popup
        };
    }
})
</script>
